/** Catálogo SAT c_ObjetoImp (CFDI 4.0). */
export const OBJETO_IMP_SAT_OPTIONS = [
  { value: '01', label: '01 - No objeto de impuesto' },
  { value: '02', label: '02 - Sí objeto de impuesto' },
  { value: '03', label: '03 - Sí objeto del impuesto y no obligado al desglose' },
  { value: '04', label: '04 - Sí objeto del impuesto y no causa impuesto' },
  { value: '05', label: '05 - Sí objeto del impuesto, IVA crédito PODEBI' },
  { value: '06', label: '06 - Sí objeto del IVA, No traslado IVA' },
  { value: '07', label: '07 - No traslado del IVA, Sí desglose IEPS' },
  { value: '08', label: '08 - No traslado del IVA, No desglose IEPS' },
]

export const OBJETO_IMP_SIN_DESGLOSE = new Set(['01', '03', '04', '08'])

export const TIPO_FACTOR_SAT_OPTIONS = [
  { value: 'Tasa', label: 'Tasa' },
  { value: 'Cuota', label: 'Cuota' },
  { value: 'Exento', label: 'Exento' },
]

export const OBJETO_IMP_DEFAULT = '02'

/** RFC genérico extranjero SAT. */
export const RFC_PUBLICO_EXTRANJERO = 'XEXX010101000'
export const RFC_PUBLICO_NACIONAL = 'XAXX010101000'

export function esRfcExtranjero(rfc) {
  return String(rfc || '').trim().toUpperCase().startsWith('XEXX')
}

export function esRfcNacional(rfc) {
  const r = String(rfc || '').trim().toUpperCase()
  return Boolean(r) && !esRfcExtranjero(r)
}

export function tipoPersonaDesdeRfc(rfc) {
  const r = String(rfc || '').trim().toUpperCase()
  if (!r || esRfcExtranjero(r) || r === RFC_PUBLICO_NACIONAL) return null
  if (r.length === 12) return 'moral'
  if (r.length === 13) return 'fisica'
  return null
}

/**
 * Retenciones solo cuando emisor PF nacional factura a receptor PM nacional.
 */
export function retencionesPermitidasPfAPm({ emisorTipo, emisorRfc, receptorTipo, receptorRfc }) {
  if (emisorTipo !== 'fisica' || receptorTipo !== 'moral') return false
  if (!esRfcNacional(emisorRfc) || !esRfcNacional(receptorRfc)) return false
  if (String(receptorRfc || '').trim().toUpperCase() === RFC_PUBLICO_NACIONAL) return false
  return true
}

/**
 * Si hay IVA/IEPS/retenciones (incl. tasa 0% o Exento), ObjetoImp debe ser 02.
 */
export function sugerirObjetoImpDesdeTraslados(rows) {
  const list = Array.isArray(rows) ? rows : []
  if (!list.length) return OBJETO_IMP_DEFAULT
  return '02'
}
